import type { ApiMiddleware, ManagedApiRequest } from '../types';

/**
 * Adds AFD-OriginURL header for localhost development with engage.cloud.microsoft credentials.
 *
 * When making API requests from localhost while authenticated to the test tenant,
 * the backend needs the AFD-OriginURL header to know to return api.engage.cloud.microsoft
 * URLs instead of www.yammer.com URLs. This ensures browser cookies work correctly.
 */
const localhostDomainMiddleware: ApiMiddleware = (request: ManagedApiRequest) => {
  if (typeof window === 'undefined' || window.location.hostname !== 'localhost') {
    return Promise.resolve(request);
  }

  return Promise.resolve({
    ...request,
    headers: {
      ...request.headers,
      'AFD-OriginURL': 'engage.cloud.microsoft',
    },
  });
};

export default localhostDomainMiddleware;
